import React from "react";
import LayoutPosSettings from "../../../../boxes/LayoutPosSettings/LayoutPosSettings";
import { Box } from "../../../../shared/Box/Box";
import classes from "./scss/PosAffirm.module.scss";
import Capabilities from "./components/Capabilities";
import { Skeleton } from "../../../../shared/Skeleton/Skeleton";
import { useAffirmCapabilities } from "./hooks/useAffirmCapabilities";

const PosAffirm = () => {
  const { data, isLoading } = useAffirmCapabilities();

  return (
    <LayoutPosSettings activeMenu="pos-affirm">
      <Box className={classes.affirmContainer}>
        <h5 className={classes.affirmTitle}>
          <span>Affirm Buy Now, Pay Later Payment Method</span>
          <span>Processing Fee: 5.1%</span>
        </h5>
        <div className={classes.affirmContent}>
          <p>
            Affirm can help your customers acquire new patients, strengthen
            relationships, and simplify payments.
          </p>
          <div className={classes.affirmBenefits}>
            <h2>Why Offer Affirm?</h2>
            <ul>
              <li>
                Life average basket size: Merchants using Affirm see up to a 70%
                increase in average purchase amounts.{" "}
                <span className={classes.footNote}>1</span>
              </li>
              <li>
                Reach high-intent patients: Access Affirm’s network of 50M+
                users.<span className={classes.footNote}>2</span>
              </li>
              <li>
                Build long-term loyalty: Transparent pricing means happier
                clients who come back.
              </li>
            </ul>
            <h2>How It Works</h2>
            <ul>
              <li>
                Allow clients to pay for their treatments interest-free in 30
                days, in 4 interest-free payments every 2 weeks, or in longer
                installments up to 36 months.
              </li>
              <li>
                Affirm pays you for each purchase up front, and provides a
                seamless experience for clients to manage their payments through
                the Affirm app.
              </li>
              <li>
                Payment plans are tailored to each basket and provide clients
                with the flexibility to choose the plan that best suits their
                individual needs and budget.
              </li>
            </ul>
          </div>
          <p>
            Affirm is managed through your existing Stripe account for payments,
            payouts, disputes and refunds. You can track your Affirm
            transactions through the POS Reconciliation Report.
          </p>
          <div className={classes.affirmFooterNotes}>
            <p>
              <span className={classes.footNote}>1</span> As reported by Affirm
              (2024)
            </p>
            <p>
              <span className={classes.footNote}>2</span> As reported by Affirm
              (2024 shareholder letter)
            </p>
            <p>
              Payment options through Affirm are subject to an eligibility
              check, may not be available everywhere, and are provided by these
              lending partners: affirm.com/lenders. CA residents: Loans by
              Affirm Loan Services, LLC are made or arranged pursuant to a
              California Financing Law license. U.S. Healthcare Service Terms
              located at{" "}
              <a
                href="https://www.affirm.com/terms/merchant-policies-stripe-healthcare"
                target="_blank"
                className={classes.link}
              >
                https://www.affirm.com/terms/merchant-policies-stripe-healthcare
              </a>
            </p>
          </div>
        </div>
      </Box>
      <Box className={classes.capabilitiesBox}>
        {isLoading ? (
          <Skeleton height={50} count={3} />
        ) : (
          <Capabilities capabilities={data?.capabilities || []} />
        )}
      </Box>
    </LayoutPosSettings>
  );
};

export default PosAffirm;
